// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLeft24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path d="M13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L9.061 12L14.5303 17.4697C14.7966 17.7359 14.8208 18.1526 14.6029 18.4462L14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L13.4697 5.46967Z" />
		</Svg>
	);
});
SvgLeft24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLeft24;
